import Vue from 'vue'

Vue.directive('modal', {
  inserted (el) {
  }
})
